import environment from '../../../common/environment';
import { getResponseData } from '../../../common/utils/api-utils';
import { FreeTrialAvailabilityResponse } from '../interfaces/free-trial-availability.interface';
import { mapFreeTrialResponse } from '../mappings/free-trial-availability.mapping';
import { FreeTrialCancelRequest } from '../interfaces/free-trial-cancel.interface';
import { getAuthenticationHeaders, getDefaultHeaders } from '../../../common/utils/auth-utils';

const BASE_API = `${environment().magentoUrl}/rest/${environment().checkoutFlow}/V1/free-trial`;

const APIS = {
  cancelFreeTrial: `${BASE_API}/mine/cancel-subscription`,
  checkFreeTrialAvailability: `${BASE_API}/mine/availability`,
  checkFreeTrialAvailabilityGuest: `${BASE_API}/guest/availability`
}

export async function checkFreeTrialAvailability(skus: string[]): Promise<FreeTrialAvailabilityResponse> {
  return mapFreeTrialResponse(await _doPostRequest(APIS.checkFreeTrialAvailability, {skus}));
}

export async function checkFreeTrialAvailabilityGuest(skus: string[]): Promise<FreeTrialAvailabilityResponse> {
  return mapFreeTrialResponse(await _doPostRequest(APIS.checkFreeTrialAvailabilityGuest, {skus}, false));
}

export async function cancelFreeTrialApiCall(freeTrialCancelRequest: FreeTrialCancelRequest) {
  return _doPostRequest(APIS.cancelFreeTrial, freeTrialCancelRequest);
}

async function _doPostRequest(url: string, requestBody: any, authenticated: boolean = true) {
  return getResponseData(
    new Request(new URL(url), {
      method: 'POST',
      credentials: 'include',
      headers: authenticated ? getAuthenticationHeaders() : getDefaultHeaders(),
      body: JSON.stringify(requestBody)
    })
  );
}